module.exports = __webpack_public_path__ + "img/movie-carousel.767a4ceb.png";